<template>
    <accordion-section title="Attributes" :loading="loading" start-open>
        <b-field v-for="(field, index) in fields" :key="`attribute-field-${field.code}`" horizontal :label="field.name">
            <b-field>
                <b-input v-model="input[field.code]" :disabled="field.updatable || !field.editable" :type="field.type"></b-input>
                <template v-slot:message>
                    <span class="is-flex is-align-items-center is-justify-content-space-between">
                        <span v-if="field.isDefault">Default value.</span>
                        <span style="margin-left: auto" v-if="field.updatable">Value controlled from source.</span>
                        <b-switch v-if="store !== 1 && !field.updatable" style="margin-left: auto" v-model="fields[index].editable">Update for store?</b-switch>
                    </span>
                </template>
            </b-field>
        </b-field>
    </accordion-section>
</template>

<script>
    export default {
        props: {
            product: {
                type: Object,
                required: true
            },
            value: {
                type: Object,
                required: false
            }
        },
        data() {
            return {
                loading: true,
                attributes: [],
                fields: [],
                input: {},
                inputTypeMapping: {
                    string: 'text',
                    text: 'textarea'
                },
                store: 1
            }
        },
        mounted() {
            this.store = this.$route.params.hasOwnProperty('store')
                ? parseInt(this.$route.params.store)
                : 1;

            axios.get('/attribute/filter', {params: {entity_type: 'product'}})
                .then(response => {
                    this.attributes = response.data;
                    this.assignData();
                    this.loading = false
                })
        },
        methods: {
            assignData() {
                let productAttributes = this.product.attribute_values;

                for (let attribute of this.attributes) {
                    this.$set(this.input, attribute.code, this.product[attribute.code])
                    let attributesPerStore = _.filter(productAttributes, {code: attribute.code})
                    let field = {
                        name: attribute.name,
                        code: attribute.code,
                        type: this.inputTypeMapping[attribute.type],
                        updatable: attribute.updatable,
                        isDefault: false,
                        editable: false
                    }

                    if (this.store === 1) {
                        field.editable = true;
                        this.fields.push(field)
                        continue;
                    }

                    if (attributesPerStore.length === 1 || !attributesPerStore.length) {
                        field.isDefault = true;
                    }

                    let attributeForStore = _.find(attributesPerStore, attr => {return attr.pivot.store_id === this.store})
                    if (attributeForStore) {
                        field.editable = true;
                    }

                    this.fields.push(field)
                }
            }
        },
        watch: {
            value: {
                deep: true,
                handler() {
                    this.input = this.value
                }
            },
            input: {
                deep: true,
                handler() {
                    this.$emit('input', this.input)
                }
            }
        }
    }
</script>
